import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/participationFees';

const fetchParticipationFees = createAction('fetchParticipationFees');

function fetchParticipationFeesSuccess(state, action) {
  const { valorCuota, minimo, maximo } = action.payload;

  state.successFetching = true;
  state.errorFetching = false;
  state.value = valorCuota;
  state.minMonthlyFee = minimo;
  state.maxMonthlyFee = maximo;
}

function fetcchParticipationFeesError(state) {
  state.successFetching = false;
  state.errorFetching = true;
  state.value = null;
  state.maxMonthlyFee = null;
  state.minMonthlyFee = null;
}

const participationFeesReducer = createSlice({
  name: 'participationFees',
  initialState,
  reducers: {
    fetchParticipationFeesSuccess,
    fetcchParticipationFeesError,
  },
});

export const participationFeesActions = {
  ...participationFeesReducer.actions,
  fetchParticipationFees,
};

export default participationFeesReducer.reducer;
